import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import React from 'react';
import { Controller, FieldPath, FieldValues, UseControllerProps } from 'react-hook-form';

interface ControlledCheckboxProps<T extends FieldValues, TName extends FieldPath<T>>
  extends UseControllerProps<T, TName> {
  label: string;
  disabled?: boolean;
  helperText?: string;
}

const ControlledCheckbox = <T extends FieldValues, TName extends FieldPath<T>>({
  label,
  disabled,
  helperText,
  ...controllerProps
}: ControlledCheckboxProps<T, TName>) => {
  return (
    <>
      <FormControlLabel
        control={
          <Controller
            {...controllerProps}
            render={({ field }) => (
              <Checkbox
                {...field}
                disabled={disabled}
                onChange={(e) => field.onChange(e.target.checked)}
                checked={Boolean(field.value)}
              />
            )}
          />
        }
        label={label}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </>
  );
};

export default ControlledCheckbox;
